import { render, staticRenderFns } from "./PostGrid.vue?vue&type=template&id=1c9e2faf&"
import script from "./PostGrid.vue?vue&type=script&lang=js&"
export * from "./PostGrid.vue?vue&type=script&lang=js&"
import style0 from "./PostGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports